import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useActiveConversationsToolbarStyles = makeStyles({
    markedResolvedBtn: {
        minHeight: '40px',
    },
    summaryGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        marginLeft: tokens.spacingHorizontalM,
        paddingLeft: tokens.spacingHorizontalM,
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: tokens.colorNeutralStroke2,
    },
    filterSearchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        marginLeft: tokens.spacingHorizontalM,
        paddingLeft: tokens.spacingHorizontalM,
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: tokens.colorNeutralStroke2,
    },
    summarisedBtn: {
        marginLeft: tokens.spacingHorizontalM,
        marginRight: tokens.spacingHorizontalS,
        minHeight: '40px',
    },
    shiftDropdownField: {
        minWidth: '160px',
        maxWidth: '180px',
        '& button': {
            minWidth: '160px',
            maxWidth: '180px',
        },
    },
    shiftDropdown: {
        minWidth: '160px',
        maxWidth: '180px',
    },
    filterBtn: {
        minHeight: '40px',
        marginRight: tokens.spacingHorizontalS,
        ...shorthands.padding('8px', tokens.spacingHorizontalS),
    },
    filterPopover: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
        minWidth: '260px',
    },
    clearFilters: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    checkboxFilter: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXS,
    },
    dropdownFilter: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXXS,
        maxWidth: '50px',
    },
    statusIndicator: {
        padding: '6px 12px',
        marginRight: tokens.spacingHorizontalM,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontWeight: 500,
        fontSize: '12px',
        minWidth: '84px',
    },
    searchInput: {
        marginLeft: tokens.spacingHorizontalS,
        maxWidth: '220px',
    },
    dialogSurface: {
        maxWidth: '360px',
    },
    summaryDialogSurface: {
        maxWidth: '900px',
        minWidth: '400px',
        padding: '20px',
    },
    dangerDialogContent: {
        color: 'var(--colorStatusDangerForeground, #d13438)',
    },
});
